import React from 'react';
import { connect } from 'react-redux';
import { changeIndicatorSearch } from './reducer';
import { SearchFilter } from '../../../common/search-filter';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';

const getListSearchFromRedux = state =>
  state[COMMON_REDUCER_NAME].listOrganizationSearch;

class SearchBox extends React.PureComponent {
  changeCode = currentSearch => {
    const { indicatorId, changeIndicatorSearch } = this.props;

    changeIndicatorSearch(indicatorId, currentSearch);
  };

  getCurrentSearch = () => {
    const { listOrganizationByOrganCode, currentSearch } = this.props;

    return listOrganizationByOrganCode[currentSearch.code] || currentSearch;
  };

  render() {
    return (
      <SearchFilter
        customWidth={null}
        isShowNameAndIndex={false}
        parentSelector=".scrollbars"
        schema={[
          { key: 'displayCode', className: 'w-20' },
          {
            key: 'codeName',
            className: 'w-55 text-truncate',
            render: text => text,
          },
          {
            key: 'exchange',
            className: 'w-25 text-right',
            render: text => text.toUpperCase(),
          },
        ]}
        listKeyFilter={['displayCode', 'exchange']}
        getListSearchFromRedux={getListSearchFromRedux}
        currentSearch={this.getCurrentSearch()}
        sortKey={'displayCode'}
        mainKey={'code'}
        clickItemSearch={this.changeCode}
      />
    );
  }
}

const mapDispatchToProps = {
  changeIndicatorSearch,
};

const mapStateToProps = state => ({
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchBox);
